/**
 * Formats a ticket file upload timestamp for UI (dd-MM-yyyy hh:mm AM/PM).
 * Uses the value returned from the API (ISO-like string), not the current clock.
 *
 * @param {string|number|Date} value - e.g. "2026-05-11T11:44:03" from backend
 * @returns {string}
 */
export function formatTicketFileUploadedAt(value) {
  if (value == null || value === '') {
    return '-';
  }
  let str = typeof value === 'string' ? value : String(value);
  if (typeof value === 'object' && value instanceof Date) {
    str = value.toISOString();
  }
  const safe = str.includes('.') ? str.substring(0, str.indexOf('.')) : str;
  const date = new Date(safe);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }
  const pad = (num) => String(num).padStart(2, '0');
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  let hours24 = date.getHours();
  const minutes = pad(date.getMinutes());
  const ampm = hours24 >= 12 ? 'PM' : 'AM';
  let hours12 = hours24 % 12;
  if (hours12 === 0) {
    hours12 = 12;
  }
  return `${day}-${month}-${year} ${pad(hours12)}:${minutes} ${ampm}`;
}
